// Jobmodal.js
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, Button } from '@mui/material';

// Expanded job listings data
const jobData = [
  {
    id: 1,
    companyName: "LitSpark Solutions",
    jobRole: "Front End Developer",
    jobType: "Full Time",
    experience: "2+ years",
    salary: "Not specified",
    skills: ["HTML", "CSS", "JavaScript", "React.js"],
    location: "Bengaluru, Karnataka",
    applyLink: "https://www.linkedin.com/jobs/view/frontend-developer-at-litspark-solutions",
  },
  {
    id: 2,
    companyName: "Multiplier",
    jobRole: "Front End Engineer",
    jobType: "Full Time",
    experience: "3+ years",
    salary: "Not specified",
    skills: ["React.js", "JavaScript", "CSS"],
    location: "Remote in Delhi, Delhi",
    applyLink: "https://www.naukri.com/job-listings-frontend-engineer-multiplier",
  },
  {
    id: 3,
    companyName: "Finpoint",
    jobRole: "Junior Front End Developer",
    jobType: "Full Time",
    experience: "0-2 years",
    salary: "Not specified",
    skills: ["HTML", "CSS", "JavaScript", "REST APIs"],
    location: "Bengaluru, Karnataka",
    applyLink: "https://www.indeed.com/viewjob?jk=junior-frontend-developer-finpoint",
  },
  {
    id: 4,
    companyName: "ABS Solutions",
    jobRole: "Front End Developer",
    jobType: "Freelance",
    experience: "Not specified",
    salary: "From ₹300,000 per year",
    skills: ["HTML", "CSS", "JavaScript"],
    location: "Jaipur, Rajasthan",
    applyLink: "https://www.jobhai.com/abs-solutions-frontend-developer-job",
  },
  {
    id: 5,
    companyName: "Firminiq Systems",
    jobRole: "Front End Developer",
    jobType: "Full Time",
    experience: "3+ years",
    salary: "Not specified",
    skills: ["React.js", "MUI", "Redux"],
    location: "Kochi, Kerala",
    applyLink: "https://www.naukri.com/job-listings-frontend-developer-firminiq-systems",
  },
  {
    id: 6,
    companyName: "Spintly India Private Limited",
    jobRole: "Front End Developer",
    jobType: "Full Time",
    experience: "Not specified",
    salary: "Not specified",
    skills: ["HTML", "CSS", "JavaScript", "React.js"],
    location: "Madgaon, Goa",
    applyLink: "https://www.linkedin.com/jobs/view/frontend-developer-at-spintly-india-private-limited",
  },
  {
    id: 7,
    companyName: "DBM INFOTECH PVT LTD",
    jobRole: "Front End Web Developer",
    jobType: "Full Time",
    experience: "3+ years",
    salary: "Not specified",
    skills: ["HTML", "CSS", "JavaScript"],
    location: "Swargate, Pune, Maharashtra",
    applyLink: "https://www.indeed.com/viewjob?jk=frontend-web-developer-dbm-infotech",
  },
  {
    id: 8,
    companyName: "EnactOn Technologies",
    jobRole: "Front End Developer (HTML, CSS, Tailwind)",
    jobType: "Full Time",
    experience: "Not specified",
    salary: "Not specified",
    skills: ["HTML", "CSS", "Tailwind CSS"],
    location: "Remote in Surat, Gujarat",
    applyLink: "https://www.naukri.com/job-listings-frontend-developer-enacton-technologies",
  },
{
  id: 10,
  companyName: "SAPGM Solutions Pvt Ltd",
  jobRole: "Backend Java Developer",
  jobType: "Full Time",
  experience: "8+ years",
  salary: "Up to ₹43,000 per month",
  skills: ["Java", "Spring Boot", "Microservices"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 11,
  companyName: "BeeSolver Technology Pvt Ltd",
  jobRole: "Java Backend Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Java", "Microservices", "Kafka"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 12,
  companyName: "Laitmatus Software Pvt Ltd.",
  jobRole: "Java Backend Developer",
  jobType: "Full Time",
  experience: "1+ years",
  salary: "Not specified",
  skills: ["Java", "Backend Development"],
  location: "Vadodara, Gujarat",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 13,
  companyName: "Barclays",
  jobRole: "Senior Java Backend Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Java", "Spring Boot", "REST APIs"],
  location: "Pune, Maharashtra",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 14,
  companyName: "Virtusa",
  jobRole: "Java Backend Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Java", "Kubernetes", "Microservices"],
  location: "Andhra Pradesh",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 15,
  companyName: "Flipped.ai",
  jobRole: "Backend Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Java", "Golang", "Node.js"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 16,
  companyName: "KRION CONSULTING Pvt Ltd",
  jobRole: "Trainer - Java Backend Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Java", "Training", "Backend Development"],
  location: "Pune, Maharashtra",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
{
  id: 17,
  companyName: "PayPal",
  jobRole: "Engineer – Backend (Java)",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Java", "Backend Development"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-java-backend-developer-jobs.html",
},
 { id: 21,
  companyName: "Tech Concierge Pro",
  jobRole: "Full Stack Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Up to ₹1,00,000 per month",
  skills: ["Next.js", "Python", "CI/CD pipelines", "AWS DevOps"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 22,
  companyName: "Slyce GmbH",
  jobRole: "Full-Stack Engineer",
  jobType: "Full Time",
  experience: "4+ years",
  salary: "Not specified",
  skills: ["React", "Node.js", "Full-stack development"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 23,
  companyName: "6DegreesIT",
  jobRole: "Senior Full Stack Developer",
  jobType: "Full Time",
  experience: "5+ years",
  salary: "Not specified",
  skills: ["React", "Full-stack development"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 24,
  companyName: "GlobalShala",
  jobRole: "Full Stack Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Front-end and back-end coding languages", "Development frameworks", "Third-party libraries"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 25,
  companyName: "Onnica Pty Ltd",
  jobRole: "Full Stack React Native Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["React Native", "Full-stack development"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 26,
  companyName: "Ocle Technologies Pvt Ltd",
  jobRole: "Full Stack Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Full-stack codebase optimization", "Performance issue resolution"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 27,
  companyName: "Traecit Business Consultants",
  jobRole: "Full Stack Developer",
  jobType: "Full Time",
  experience: "3-6 years",
  salary: "Not specified",
  skills: ["Web application development"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},
{
  id: 28,
  companyName: "LunaJoy",
  jobRole: "Senior Full Stack Developer",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Team leadership", "Technical solution deployment"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-full-stack-developer-l-india-remote-jobs.html",
},

{
  id: 41,
  companyName: "IBM",
  jobRole: "Power Hardware Technical Support Professional",
  jobType: "Full Time",
  experience: "2+ years",
  salary: "Not specified",
  skills: ["Technical Support", "Hardware Troubleshooting"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 42,
  companyName: "Atlassian",
  jobRole: "Associate Technical Support Engineer",
  jobType: "Full Time",
  experience: "1-3 years",
  salary: "Not specified",
  skills: ["Customer Support", "Technical Problem Solving"],
  location: "Remote in Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 43,
  companyName: "Wing Assistant",
  jobRole: "Technical Support Representative",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Tech Support", "Customer Service"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 44,
  companyName: "American Express Global Business Travel",
  jobRole: "Technical Support Specialist",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Technical Support", "Client Assistance"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 45,
  companyName: "Etech",
  jobRole: "Technical Support Analyst",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Technical Support", "Problem Solving"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 46,
  companyName: "Sieva Networks Solutions Pvt Ltd",
  jobRole: "Customer Service (Tech Support)",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Customer Service", "Technical Support"],
  location: "Remote in Hyderabad, Telangana",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 47,
  companyName: "Stardawn IT",
  jobRole: "Technical Support Engineer (L3)",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Technical Support", "Troubleshooting"],
  location: "Remote",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 48,
  companyName: "TTEC",
  jobRole: "Chat Technical Support Representative",
  jobType: "Full Time",
  experience: "1+ years",
  salary: "Not specified",
  skills: ["Chat Support", "Technical Troubleshooting"],
  location: "Mumbai, Maharashtra",
  applyLink: "https://in.indeed.com/q-technical-support-jobs.html",
},
{
  id: 51,
  companyName: "BigSpire Software",
  jobRole: "Computer Operator and Data Entry - Freshers",
  jobType: "Full Time",
  experience: "Fresher",
  salary: "Not specified",
  skills: ["Good communication skills", "Knowledge in MS Office", "Good typing skills"],
  location: "Banaswadi, Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 52,
  companyName: "Sagacious Infosystems Pvt Ltd",
  jobRole: "Data Entry Executive",
  jobType: "Full Time",
  experience: "Fresher",
  salary: "₹14,000 - ₹15,000 per month",
  skills: ["Identify and correct data entry errors", "Adhere to company policies"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 53,
  companyName: "KTWO Healthcare India Pvt. Ltd.",
  jobRole: "Data Entry Coordinator",
  jobType: "Full Time",
  experience: "1+ years",
  salary: "Not specified",
  skills: ["Basic skills in internet browsing", "Excel", "Google Sheets"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 54,
  companyName: "Dyuti Technologies",
  jobRole: "Data Entry Operator",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Complete knowledge of title search", "Close contact with subject matter experts"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 55,
  companyName: "RajaRajeswari Medical College & Hospital",
  jobRole: "Data Entry Operator",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Open and healthy academic environment", "Growth opportunities"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 56,
  companyName: "Europe Express",
  jobRole: "Data Entry Specialist",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Good understanding of specified documents", "Work hours: 10 am - 7 pm IST"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 57,
  companyName: "Adwika Solutions",
  jobRole: "Data Entry Executive",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Create & maintain critical data repositories", "Good in MS Office Tools"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
{
  id: 58,
  companyName: "EatEasily Online Pvt. Ltd.",
  jobRole: "Data Executive",
  jobType: "Full Time",
  experience: "Not specified",
  salary: "Not specified",
  skills: ["Adhere to data confidentiality principles", "Strong command of English"],
  location: "Bengaluru, Karnataka",
  applyLink: "https://in.indeed.com/q-data-entry-l-bengaluru%2C-karnataka-jobs.html",
},
];

function Jobmodal({ open, handleClose, jobId }) {
  // Find the job data based on the jobId passed
  const job = jobData.find(job => job.id === jobId);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        {job ? (
          <>
            <Typography variant="h6" gutterBottom>
              {job.companyName}
            </Typography>
            <Typography>Job Role: {job.jobRole}</Typography>
            <Typography>Job Type: {job.jobType}</Typography>
            <Typography>Quailification: {job.qualification}</Typography>
            <Typography>Experience: {job.experience}</Typography>
            <Typography>Salary: {job.salary}</Typography>
            <Typography>Location: {job.location}</Typography>
            
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              href={job.applyLink} // Redirect to application link
              target="_blank"
            >
              Apply Now
            </Button>
          </>
        ) : (
          <Typography variant="body2">Job details not found</Typography>
        )}
      </Box>
    </Modal>
  );
}

Jobmodal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  jobId: PropTypes.number.isRequired,
};

export default Jobmodal;
